function getDefault() {
  return {
    id: null,
    title: '',
    date: '',
    state: null,
    person: null,
  };
}

function makeTicket(data) {
  if (data === undefined) {
    return getDefault();
  }

  const processedData = {
    id: data.id,
    title: data.title,
    date: data.date,
    state: data.state,
    person: data.person,
  };

  return { ...data, ...processedData };
}

export default makeTicket;
